/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { SAMPLE_TO_SALE_SCREEN, COMMON } from '../../global/Constants';
import ViewImage from '../common/ViewImage';
import './sample-to-sale.css';
//import ViewImage from '../common/ViewImage';

class FieldDayView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"],

        }
    }


    getTotalCommitment(data) {
        //const { data } = this.state;

        var farmerCommitment = 0;
        farmerCommitment = 0 + parseInt(data?.farmer_commitment);

        var retailerCommitmentTotal = 0;
        data?.field_day_dealers.forEach(function (obj) {
            retailerCommitmentTotal += parseInt(obj.commitment);
        });

        var prerakCommitmentTotal = 0;
        data?.field_day_preraks.forEach(function (obj) {
            prerakCommitmentTotal += parseInt(obj.commitment);
        });

        var total = farmerCommitment + retailerCommitmentTotal + prerakCommitmentTotal;
        //Utilities.LogPrint("Total", total);

        return total;
    }


    getFarmerNumbers() {
        const { fieldDayStage } = this.props;
        const numbers = [];
        if (fieldDayStage?.field_day_farmers) {
            fieldDayStage?.field_day_farmers.forEach(function (item) {
                if (item.is_phone === 1) {
                    numbers.push(item.phone_image);
                }
            })
        }
        return numbers;
    }

    getFarmerNumberImages() {
        const { fieldDayStage } = this.props;
        const numberImages = [];
        if (fieldDayStage?.field_day_farmers) {
            fieldDayStage?.field_day_farmers.forEach(function (item) {
                if (item.is_phone === 0) {
                    numberImages.push({ image_url: item.phone_image });
                }
            })
        }
        return numberImages;
    }

    render() {
        const { fieldDayStage } = this.props;
        if (fieldDayStage != null) {
            return (
                <div className="row">
                    <div className="col-12 px-sm-3">
                        <h6 className="font-weight-medium">{SAMPLE_TO_SALE_SCREEN.ATTENDED_BY}</h6>

                        <div className="row mb-2">
                            <div className="col-4">
                                <span className="d-block">{SAMPLE_TO_SALE_SCREEN.MANAGERS}</span>
                                <span className="d-block font-weight-medium">{fieldDayStage?.field_day_manager_bies?.length}</span>
                            </div>
                            <div className="col-8">
                                <span className="d-block">{COMMON.LEVEL}</span>
                                {/* <span className="d-block font-weight-medium">{SAMPLE_TO_SALE_SCREEN.TERRITORY_MANAGERS}</span> */}
                                {
                                    fieldDayStage?.field_day_manager_bies.length ?
                                        fieldDayStage?.field_day_manager_bies.map((item, i) => (
                                            <span key={i} className="d-block font-weight-medium">{item.field_day_manager_name}</span>
                                        )) : null
                                }

                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-4">
                                <span className="d-block">{COMMON.FARMERS}</span>
                                <span className="d-block font-weight-medium">{fieldDayStage?.farmer_count}</span>
                            </div>
                            <div className="col-8">
                                <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                                <span className="d-block font-weight-medium">{fieldDayStage?.farmer_commitment} kg</span>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-4">
                                <span className="d-block">{SAMPLE_TO_SALE_SCREEN.RETAILERS}</span>
                                <span className="d-block font-weight-medium">{fieldDayStage?.field_day_dealers?.length}</span>
                            </div>
                            <div className="col-4">
                                <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                                {/* <span className="d-block font-weight-medium">10 kg</span> */}
                                {
                                    fieldDayStage?.field_day_dealers.length ?
                                        fieldDayStage?.field_day_dealers.map((item, i) => (
                                            <span key={i} className="d-block font-weight-medium">{item.commitment} kg</span>
                                        )) : null
                                }
                            </div>
                            <div className="col-4">
                                <span className="d-block">{COMMON.NAME}</span>
                                {/* <span className="d-block font-weight-medium">Retailer One</span> */}
                                {
                                    fieldDayStage?.field_day_dealers.length ?
                                        fieldDayStage?.field_day_dealers.map((item, i) => (
                                            <span key={i} className="d-block font-weight-medium">{item.field_day_dealer_name} </span>
                                        )) : null
                                }
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-4">
                                <span className="d-block">{COMMON.PRERAK}</span>
                                <span className="d-block font-weight-medium">{fieldDayStage?.field_day_preraks.length}</span>
                            </div>
                            <div className="col-4">
                                <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                                {/* <span className="d-block font-weight-medium">10 kg</span> */}
                                {
                                    fieldDayStage?.field_day_preraks.length ?
                                        fieldDayStage?.field_day_preraks.map((item, i) => (
                                            <span key={i} className="d-block font-weight-medium">{item.commitment} kg</span>
                                        )) : null
                                }
                            </div>
                            <div className="col-4">
                                <span className="d-block">{COMMON.NAME}</span>
                                {/* <span className="d-block font-weight-medium">Prerak One</span> */}
                                {
                                    fieldDayStage?.field_day_preraks.length ?
                                        fieldDayStage?.field_day_preraks.map((item, i) => (
                                            <span key={i} className="d-block font-weight-medium">{item.field_day_prerak_name}</span>
                                        )) : null
                                }
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-4 offset-4">
                                <span className="d-block">{COMMON.TOTAL}</span>
                                <span className="d-block font-weight-medium">{this.getTotalCommitment(fieldDayStage)} kg</span>
                            </div>
                        </div>

                        <div className="row m-md-0">
                            <hr className="w-100" />
                        </div>

                        <div className="row mt-3 mb-2">
                            <div className="col-lg-4 col-12 d-flex align-items-center">
                                <label className="mb-0 mr-3">Farmer Mobile Numbers</label>
                            </div>
                            <div className="col-lg-8 col-12">
                                <span className="d-block font-weight-medium">{this.getFarmerNumbers().join(",  ")} </span>
                                {/* <input type="text" class="form-control min-w-360" value="+91 - 98765 43210, +91 - 98765 43210, +91 - 98765 43210, +91 - 98765 43210" /> */}
                            </div>
                        </div>
                        <div className="row row7-5 mb-3">

                            <div className="col-lg-4 col-12"></div>
                            <div className="col-lg-8 col-12">
                                <div className="row">
                                    {
                                        this.getFarmerNumberImages().length ?
                                            this.getFarmerNumberImages().map((image, i) => (
                                                <ViewImage key={i} image={image.image_url} />
                                                // <div key={i} className="col-lg-3 col-4 image-info">
                                                //     <img src={image} alt="" />
                                                // </div>
                                            )) : null
                                    }
                                    {/* <div className="col-lg-3 col-4 image-info">
                                        <img src="../assets/images/krishak-info-img1.png" alt="" />
                                    </div>
                                    <div className="col-lg-3 col-4 image-info">
                                        <img src="../assets/images/krishak-info-img2.png" alt="" />
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="row m-md-0">
                            <hr className="w-100" />
                        </div>

                        <div className="row mt-3 mb-3">
                            <div className="col-4">
                                {COMMON.FEEDBACK}
                            </div>
                            <div className="col-8">
                                <span className="d-block font-weight-medium">{fieldDayStage?.feedback}</span>
                            </div>
                        </div>
                        <div className="row m-md-0">
                            <hr className="w-100" />
                        </div>
                        <div className="row row7-5 mb-3">
                            <div className="col-12 col-md-6 offset-md-6">
                                <div className="row">
                                    <div className="col-md-12">
                                        <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{COMMON.IMAGES}</span>
                                    </div>
                                    {/* Images Info */}
                                    {
                                        fieldDayStage?.images.length ?
                                            fieldDayStage?.images.map((image, i) => (
                                                <ViewImage key={i} image={image.image_url} />
                                                // <div key={i} className="col-4 image-info">
                                                //     <img src={image.image_url} alt="" />
                                                // </div>
                                            )) : null
                                    }
                                    {/* <ViewImage styleName="row mt-2" images={this.state.images} /> */}
                                </div>
                            </div>
                        </div>
                        <div className="row m-md-0 d-md-none">
                            <hr className="w-100" />
                        </div>
                    </div>
                </div>

                // <div className="row">
                //     <div className="col-12 px-sm-3">
                //         <h6 className="font-weight-medium">{SAMPLE_TO_SALE_SCREEN.ATTENDED_BY}</h6>

                //         <div className="row mb-2">
                //             <div className="col-4">
                //                 <span className="d-block">{SAMPLE_TO_SALE_SCREEN.MANAGERS}</span>
                //                 <span className="d-block font-weight-medium">2</span>
                //             </div>
                //             <div className="col-8">
                //                 <span className="d-block">{COMMON.LEVEL}</span>
                //                 <span className="d-block font-weight-medium">{SAMPLE_TO_SALE_SCREEN.TERRITORY_MANAGERS}</span>
                //             </div>
                //         </div>
                //         <div className="row mb-2">
                //             <div className="col-4">
                //                 <span className="d-block">{COMMON.FARMERS}</span>
                //                 <span className="d-block font-weight-medium">8</span>
                //             </div>
                //             <div className="col-8">
                //                 <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                //                 <span className="d-block font-weight-medium">10 kg</span>
                //             </div>
                //         </div>
                //         <div className="row mb-2">
                //             <div className="col-4">
                //                 <span className="d-block">{SAMPLE_TO_SALE_SCREEN.RETAILERS}</span>
                //                 <span className="d-block font-weight-medium">1</span>
                //             </div>
                //             <div className="col-4">
                //                 <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                //                 <span className="d-block font-weight-medium">10 kg</span>
                //             </div>
                //             <div className="col-4">
                //                 <span className="d-block">{COMMON.NAME}</span>
                //                 <span className="d-block font-weight-medium">Retailer One</span>
                //             </div>
                //         </div>
                //         <div className="row mb-2">
                //             <div className="col-4">
                //                 <span className="d-block">{COMMON.PRERAK}</span>
                //                 <span className="d-block font-weight-medium">2</span>
                //             </div>
                //             <div className="col-4">
                //                 <span className="d-block">{SAMPLE_TO_SALE_SCREEN.COMMITMENT}</span>
                //                 <span className="d-block font-weight-medium">10 kg</span>
                //                 <span className="d-block font-weight-medium">10 kg</span>
                //             </div>
                //             <div className="col-4">
                //                 <span className="d-block">{COMMON.NAME}</span>
                //                 <span className="d-block font-weight-medium">Prerak One</span>
                //                 <span className="d-block font-weight-medium">Prerak Two</span>
                //             </div>
                //         </div>
                //         <div className="row mb-2">
                //             <div className="col-4 offset-4">
                //                 <span className="d-block">{COMMON.TOTAL}</span>
                //                 <span className="d-block font-weight-medium">40 kg</span>
                //             </div>
                //         </div>
                //         <div className="row mb-2">
                //             <div className="col-4">
                //                 {COMMON.FEEDBACK}
                //             </div>
                //             <div className="col-8">
                //                 <span className="d-block font-weight-medium">{COMMON.GOOD}</span>
                //             </div>
                //         </div>
                //         <div className="row m-md-0">
                //             <hr className="w-100" />
                //         </div>
                //         <div className="row row7-5 mb-3">
                //             <div className="col-12 col-md-6 offset-md-6">
                //                 <div className="row">
                //                     <div className="col-md-12">
                //                         <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{SAMPLE_TO_SALE_SCREEN.IMAGES}</span>
                //                     </div>
                //                     {/* Images Info */}
                //                     {
                //                         this.state.images.length ?
                //                             this.state.images.map((image, i) => (
                //                                 <div key={i} className="col-4 image-info">
                //                                     <img src={image} alt="" />
                //                                 </div>
                //                             )) : null
                //                     }
                //                     {/* <ViewImage styleName="row mt-2" images={this.state.images} /> */}
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="row m-md-0 d-md-none">
                //             <hr className="w-100" />
                //         </div>
                //     </div>
                // </div>
            )
        } else {
            return null;
        }
    }
}

export default withRouter(FieldDayView);